import { rem } from 'polished'
import React, { useMemo } from 'react'
import { CMS_EXPERT_PAGE_SLUGS } from 'shared-constants'
import styled from 'styled-components'
import { EXPERT_SHOWROOM_PRODUCTS_LISTING_ID } from '@public/ExpertDetail/utils'
import { WidgetsWrapper } from 'components/Widgets'
import { COLLECTION_WIDGET_LIMIT } from 'constants/common'
import { SPACE, WIDGET_MAX_WIDTH, mq } from 'Theme'
import {
  ProductSorterField,
  ProductStatus,
  ProductVariantStatus,
  SortDirection,
  useCmsExpertPageBySlugQuery,
} from 'types/graphql-generated'
import { useMedia } from 'useMedia'

const Wrapper = styled.div`
  width: 100%;
  scroll-margin-top: ${SPACE.PX_100};
  ${mq.from.TABLET`
      scroll-margin-top: ${SPACE.PX_48}; 
   `}
`

interface ShowroomTabContentProps {
  slug: string
  expertId: number
}

export const ShowroomTabContent: React.FC<ShowroomTabContentProps> = ({
  slug,
  expertId,
}) => {
  const { MOBILE: isMobile } = useMedia()
  const { data: cmsPageData } = useCmsExpertPageBySlugQuery({
    fetchPolicy: 'cache-first',
    variables: {
      slug: CMS_EXPERT_PAGE_SLUGS.SHOWROOM(expertId),
      widgetsDefaultInputs: {
        cmsMultiCollectionProductsInput: {
          pagination: {
            page: 1,
            limit: isMobile
              ? COLLECTION_WIDGET_LIMIT.MOBILE
              : COLLECTION_WIDGET_LIMIT.DESKTOP,
          },
          sorter: {
            field: ProductSorterField.PositionIndexWeight,
            direction: SortDirection.Asc,
          },
          filter: {
            statuses: [ProductStatus.Published],
            variantStatuses: [ProductVariantStatus.Published],
          },
        },
      },
    },
  })

  const widgets = useMemo(
    () => cmsPageData?.cmsExpertPageBySlug?.cmsPage?.widgets || [],
    [cmsPageData]
  )

  return (
    <Wrapper id={EXPERT_SHOWROOM_PRODUCTS_LISTING_ID}>
      <WidgetsWrapper
        widgets={widgets}
        slug={slug}
        mt={rem(25)}
        mb={{ TABLET: SPACE.PX_40, MOBILE: SPACE.PX_5 }}
        maxWidgetWidth={WIDGET_MAX_WIDTH.ARTICLE}
        isSearchFilterParamsMode
      />
    </Wrapper>
  )
}
